import * as React from 'react';
import * as classNames from 'classnames';

export enum ModalSize {
    Small = 'modal-sm',
    Normal = '',
    Large = 'modal-lg',
    ExtraLarge = 'modal-xl',
}

export enum ModalStyleType {
    Primary = 'type-primary',
    Danger = 'type-danger',
    Warning = 'type-warning',
    Success = 'type-success',
}

interface ModalProps {
    show?: boolean;
    dismountOnHide?: boolean;
    header?: string | React.ReactNode;
    size?: ModalSize;
    styleType?: ModalStyleType;
    zIndex?: number;
    closeModalHandler?: React.MouseEventHandler | undefined;
    automationId?: string;
    children: React.ReactNode;
}


export const Modal = ({ show, dismountOnHide = true, header, zIndex, closeModalHandler, automationId, children, size = ModalSize.Normal, styleType = ModalStyleType.Primary }: ModalProps) => {
    if (!show && dismountOnHide) return null;

    const sizeClass = classNames('modal-dialog', size);

    const modalClasses = classNames('modal', { 'show': show }, 'bootstrap-dialog', styleType);

    return (
        <div>
            {show ? <div className="modal-backdrop fade in"></div> : null}
            <div style={{ zIndex: zIndex }} className={modalClasses} role="dialog" data-automationid={automationId || "Modal"}>
                <div className={sizeClass} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="bootstrap-dialog-header">
                                <div className="bootstrap-dialog-title">
                                    {header}
                                </div>
                                {closeModalHandler ?
                                    <button type="button" data-dismiss="modal" className="close" aria-label="Close" onClick={closeModalHandler}><span aria-hidden="true">&times;</span></button>
                                    : null
                                }
                            </div>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;
